var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 45V53.9999H38.9999V45H30ZM35.9999 50.9999H33V48H35.9999V50.9999Z",
    fill: "#203468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 45V53.9999H50.9999V45H42ZM47.9999 50.9999H45V48H47.9999V50.9999Z",
    fill: "#203468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4994 56.9994H56.9994V32.9997H53.9995V29.9997H50.9995V32.9997H47.9995V38.9996H44.9996V32.9997V26.9997H41.9996V32.9997H38.9996V23.9998H35.9997V32.9997V38.9996H32.9997V32.9997H29.9997V26.9997H26.9997V32.9997H23.9998V56.9994H17.9998V23.9998H20.9998C22.6568 23.9998 23.9998 22.6568 23.9998 20.9998V17.9998H50.9995V26.9997H53.9995V17.9998H56.9994C58.3904 17.9998 59.5995 17.0429 59.9194 15.6888C60.2394 14.3348 59.5854 12.9388 58.3413 12.3169L52.3414 9.3169C51.9245 9.1089 51.4654 8.99991 50.9994 8.99991H18.3278L14.6829 1.65795C14.1669 0.62601 13.1169 0 12.0009 0C11.772 0 11.541 0.0260154 11.3109 0.0809758C9.95686 0.399957 8.99991 1.60897 8.99991 2.99997V8.99991H2.99997C1.34296 8.99991 0 10.3429 0 11.9999V14.9999C0 16.6569 1.34296 17.9998 2.99997 17.9998H8.99991V20.9998V56.9994H1.49999C0.671009 56.9994 0 57.6705 0 58.4994C0 59.3284 0.671009 59.9994 1.49999 59.9994H58.4994C59.3284 59.9994 59.9994 59.3284 59.9994 58.4994C59.9994 57.6705 59.3284 56.9994 58.4994 56.9994ZM8.99991 14.9999H2.99997V11.9999H8.99991V14.9999ZM50.9995 11.9999L56.9994 14.9999H23.9998C23.9998 14.2038 23.6837 13.4409 23.1208 12.8789L22.2428 11.9999H50.9995ZM11.9999 2.99997L14.9999 8.99991H11.9999V2.99997ZM11.9999 11.9999H17.9998L20.9998 14.9999V20.9998H11.9999V11.9999ZM14.9999 56.9994H11.9999V23.9998H14.9999V56.9994ZM53.9995 56.9994H26.9997V35.9997H29.9997V41.9996H38.9996V35.9997H41.9996V41.9996H50.9995V35.9997H53.9995V56.9994Z",
    fill: "#203468"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/Portfolio.2a6fabff9c157e83b4ce02c4006c6d77.svg";
export { ForwardRef as ReactComponent };